import React from "react";
import { Box, Paper, Typography, Divider, Link } from "@mui/material";
import imgUrl from "../assets/images/imgUrl";

const sections = [
  {
    title: "1. Introduction",
    content: [
      "This Privacy Policy explains how Jupiter Events LLC, and its initiatives (Global Justice, Love & Peace Summit, I Am Peacekeeper Movement, and Billionaires for Peace) under the Chairmanship of Dr. Huzaifa Khorakiwala, collect, use, share and protect your personal data.",
      "This Policy applies to all visitors, users, and participants who engage with our website(s) and mobile application(s), globally, including but not limited to jurisdictions of India, United Arab Emirates (UAE), the European Union (GDPR), and other international territories.",
      "By accessing or using our services, you consent to the terms of this Privacy Policy."
    ]
  },
  {
    title: "2. Information We Collect",
    content: [
      "We may collect the following categories of data:",
      "• Personal Identification Data: Name, email, phone number, date of birth, nationality, gender, and user profile information.",
      "• Technical Data: IP address, browser type, device identifiers, app version, location (approximate, not precise).",
      "• Usage Data: App interactions, event participation, preferences, messages, and user-generated content.",
      "• Financial Data (if applicable): Payment details (processed securely via third-party gateways – we do not store card numbers or banking credentials)."
    ]
  },
  {
    title: "3. How We Use Your Information",
    content: [
      "Your information will be used for purposes including:",
      "• To provide, maintain and improve our services.",
      "• To register and authenticate users.",
      "• To facilitate participation in events, clubs, forums and initiatives.",
      "• To send communications, newsletters, or updates (opt-in only).",
      "• To comply with legal obligations in India, UAE and international law.",
      "• To detect, prevent and address fraud or technical issues."
    ]
  },
  {
    title: "4. Legal Basis for Processing (GDPR & International Compliance)",
    content: [
      "We process personal data on the following bases:",
      "• Consent: When you register, subscribe or participate voluntarily.",
      "• Contractual necessity: To provide services requested by you.",
      "• Legal compliance: To meet regulatory requirements.",
      "• Legitimate interest: To enhance services, prevent misuse, and ensure community safety."
    ]
  },
  {
    title: "5. Data Sharing and Transfers",
    content: [
      "• Data may be shared with Jupiter Events LLC subsidiaries, partners, or service providers strictly for operational purposes.",
      "• Cross-border transfers (e.g., India UAE EU/International) will comply with applicable data protection laws.",
      "• No data will be sold to third parties."
    ]
  },
  {
    title: "6. Children’s Privacy",
    content: [
      "Our platforms are designed for individuals aged 13 years and above. For those under 18, parental or guardian consent is required where mandated by local law."
    ]
  },
  {
    title: "7. Data Security",
    content: [
      "We adopt strong security measures, including:",
      "• Encryption (SSL/TLS) for web and app data transmission.",
      "• Role-based access to databases.",
      "• Regular audits and compliance checks."
    ]
  },
  {
    title: "8. Data Retention",
    content: [
      "• Personal data will be retained only for as long as necessary for service delivery, legal, and audit purposes.",
      "• Users may request deletion of their accounts and associated data at any time."
    ]
  },
  {
    title: "9. User Rights",
    content: [
      "Depending on jurisdiction, users may exercise rights such as:",
      "• Access to their personal data.",
      "• Request correction or deletion.",
      "• Restrict or object to processing.",
      "• Data portability (where applicable).",
      "• Withdrawal of consent.",
      <>
      Requests may be made via 
         <Link
              href="mailto:peace@i-am-peacekeeper.com"
              className="cursor-pointer"
            > peace@i-am-peacekeeper.com</Link>.
      </>
      
    ]
  },
  {
    title: "10. Cookies and Tracking",
    content: [
      "Our website and app may use cookies or similar technologies for functionality and analytics. Users may disable cookies in their browser settings, though some features may be limited."
    ]
  },
  {
    title: "11. Third-Party Services",
    content: [
      "Our platforms may integrate with third-party services (e.g., payment gateways, communication APIs). These are governed by their own privacy policies, which we encourage you to review."
    ]
  },
  {
    title: "12. Governing Law and Jurisdiction",
    content: [
      "• For users in India: Indian IT Act, 2000 and Data Protection Rules apply.",
      "• For users in UAE: Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data applies.",
      "• For EU/International: GDPR and other relevant global privacy laws apply."
    ]
  },
  {
    title: "13. Updates to Privacy Policy",
    content: [
      "This Policy may be updated from time to time. Updates will be notified via the website/app and effective upon posting."
    ]
  },
  {
    title: "14. Contact Information",
    content: [
      "For privacy concerns, please contact:",
      "Jupiter Events LLC",
      "Mr. Taiyzun Shahpurwala",
      "Director, Office of Dr. Huzaifa Khorakiwala",
      <>📧 Email
         <Link
              href="mailto:peace@i-am-peacekeeper.com"
              className="cursor-pointer"
            > peace@i-am-peacekeeper.com</Link>
      </>
      
    ]
  }
];

const PrivacyPolicy = () => {
  return (
    <Box
      className="privacy-root sectionBgImg"
      sx={{
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden"
      }}
    >
      <Paper
        elevation={5}
        sx={{ p: 4, m: 5, borderRadius: 2 }}
        className="UserSubSection privacyPolicySection"
      >
        {/* Logo */}
        <Box sx={{ mb: 2, textAlign: "center" }}>
          <img src={imgUrl.peaceMovImg} alt="Logo" width="100" />
        </Box>

        {/* Heading */}
        <Typography
          variant="h6"
          fontWeight="400"
          textAlign="center"
          mb={0}
          className="loginHeading"
        >
         📜 International Privacy Policy Jupiter Events LLC (Website & Application) 
        </Typography>
        {/* <Typography
          variant="body2"
          color="text.secondary"
          mb={3}
          textAlign="center"
        >
          Privacy Policy for peacekeeper only
        </Typography> */}

        <Box>
          {/* <Typography fontWeight="800" gutterBottom color="text.secondary">
            Effective Date: 19th August , 2025
          </Typography> */}

          {/* Sections */}
          {sections.map((section, index) => (
            <Box key={index} className="privacy-section">
              <Divider className="privacy-divider" />
              <Typography fontWeight="600" gutterBottom mt={2} mb={2}>
                {section.title}
              </Typography>
              {section.content.map((line, i) => (
                <Typography key={i} paragraph>
                  {line}
                </Typography>
              ))}
            </Box>
          ))}

          {/* Footer Contact Links */}
          <Divider className="privacy-divider" />
         
        </Box>
      </Paper>
    </Box>
  );
};

export default PrivacyPolicy;
